import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_material_catalogs_hub_ComponentContextService } from './FootprintManager.material_catalogs_hub.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { FootprintManager_material_catalog_source_materials_gridComponent } from './FootprintManager.material_catalog_source_materials_grid.component';
import { FootprintManager_material_catalogs_project_subscribers_gridComponent } from './FootprintManager.material_catalogs_project_subscribers_grid.component';
import { Catalogs_material_catalogs_dd_singleComponent } from './Catalogs.material_catalogs_dd_single.component'

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootprintManager_material_catalog_source_materials_gridComponent),
    forwardRef(() => FootprintManager_material_catalogs_project_subscribers_gridComponent),
    forwardRef(() => Catalogs_material_catalogs_dd_singleComponent),
  ],
  selector: 'FootprintManager-material_catalogs_hub',
  templateUrl: './FootprintManager.material_catalogs_hub.component.html'
})
export class FootprintManager_material_catalogs_hubComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  inParams: { project_id?: number, material_catalog_id?: number } = { project_id: null, material_catalog_id: null };
  //#region Inputs
  @Input('project_id') set $inParams_project_id(v: number) {
    this.inParams.project_id = v;
  }
  get $inParams_project_id(): number {
    return this.inParams.project_id;
  }
  @Input('material_catalog_id') set $inParams_material_catalog_id(v: number) {
    this.inParams.material_catalog_id = v;
  }
  get $inParams_material_catalog_id(): number {
    return this.inParams.material_catalog_id;
  }
  //#endregion Inputs

  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  formGroup: FormGroup = new FormGroup({
    material_catalogs: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });
  
  toolbar = {
      material_catalogs: new ToolModel(new ButtonModel('material_catalogs', new ButtonStyles(null, null), false, false, false, 'Manage catalogs', 'icon-ic_fluent_settings_20_regular', null)
    , false)
  };

  actionbar = {
  };

 filters = {
    material_catalogs: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['material_catalogs'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Material catalog', false, false),
  };


  filtersets = {
    newGroup1: new FieldsetModel(
      'Filters',
      true,
      false,
      true,
      false,
        null
      ,
      () => {
        const $hub = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      source_materials: new TabItemModel(
        this.rootTabGroup, 
        'Source materials', 
        false,
        ),
      project_subscribers: new TabItemModel(
        this.rootTabGroup, 
        'Project subscribers', 
        false,
        ),
    };
  
  
    //#region tabs inParams
    get $tabs_source_materials_material_catalog_source_materials_grid_inParams_catalog_id(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.material_catalogs.control.value;
      
      return expr;
    }
  
    get $tabs_project_subscribers_material_catalogs_project_subscribers_grid_inParams_catalog_id(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.material_catalogs.control.value;
      
      return expr;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_source_materials', { read: FootprintManager_material_catalog_source_materials_gridComponent }) $tabs_source_materials: FootprintManager_material_catalog_source_materials_gridComponent;
      @ViewChild('$tabs_project_subscribers', { read: FootprintManager_material_catalogs_project_subscribers_gridComponent }) $tabs_project_subscribers: FootprintManager_material_catalogs_project_subscribers_gridComponent;
    //#endregion tabs children

  //#region filters inParams
  //#endregion filters inParams

  get hubTitle(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Material catalogs`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Your landing page to view material catalogs and all related actions.`;
  }

  constructor(
  private $utils: UtilsService,
  private $settings: SettingsValuesService,
  private $shell: FootprintManager_ShellService,
  private $datasources: FootprintManager_DatasourceService,
  private $flows: FootprintManager_FlowService,
  private $reports: FootprintManager_ReportService,
  private $localization: FootprintManager_LocalizationService,
  private $operations: FootprintManager_OperationService,
  private $logger: CleanupLoggerService,
  private $context: FootprintManager_material_catalogs_hub_ComponentContextService,
  ) { 
    super();
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.source_materials,
      this.tabs.project_subscribers,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'Material catalogs Hub';
    
    const $hub = this;
    const $utils = this.$utils;


    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region tabs children
    if (childToSkip !== '$tabs_source_materials') {
      if (!isNil(this.$tabs_source_materials) && !this.tabs.source_materials.hidden) {
        this.$tabs_source_materials.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_project_subscribers') {
      if (!isNil(this.$tabs_project_subscribers) && !this.tabs.project_subscribers.hidden) {
        this.$tabs_project_subscribers.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_manage_catalogs_clicked(event = null) {
    return this.on_manage_catalogs_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_manage_catalogs_clickedInternal(
    $hub: FootprintManager_material_catalogs_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_material_catalogs_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  await $shell.FootprintManager.openmaterial_catalogs_gridDialog('flyout',EModalSize.Xlarge);
  
  $hub.on_init();
  $hub.refresh();
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: FootprintManager_material_catalogs_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_material_catalogs_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  let material_catalogs = (await $datasources.Catalogs.ds_material_catalogs_dd.get({})).result;
  
  if ($utils.isDefined(material_catalogs)){
      $hub.filters.material_catalogs.control.value = material_catalogs[0]?.Id;
  }
  
  
  }
  //#endregion private flows
}
